type TableProps = {
  size?: number;
  color?: string;
};

export function Table({ size = 28, color = 'currentColor' }: TableProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.89543 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 4H11V7H15V4ZM15 8H11V11H15V8ZM15 12H11V15H14C14.5523 15 15 14.5523 15 14V12ZM10 15V12H6V15H10ZM5 15V12H1V14C1 14.5523 1.44772 15 2 15H5ZM1 11H5V8H1V11ZM1 7H5V4H1V7ZM6 4V7H10V4H6ZM10 8H6V11H10V8Z"
        fill={color}
      />
    </svg>
  );
}
